<section>
  <h1>Written Word Media Terms and Conditions</h1>
</section>
